require('./bootstrap');

if (document.getElementById('circleText')) {
    lettering.splitter(document.getElementById("circleText"));
}


// Show hidden text;
var el = document.getElementById("toggleHiddenText");


if (el) {
    el.addEventListener('click', function () {
        var element = document.getElementById("hiddenText");
        element.classList.toggle("opened");

        var readMore = el.getAttribute('data-read_more');
        var readLess = el.getAttribute('data-read_less');

        el.classList.toggle("opened");
        console.log(el.classList.contains('opened'));

        if (el.classList.contains('opened')) {
            el.innerHTML = readLess;
        } else {
            el.innerHTML = readMore;
        }
    });
}

// Handle cookies section;
if (document.getElementById("cookiesBlock")) {
    document.getElementById("cookiesDisagree").addEventListener('click', function () {
        var link = document.getElementById("cookiesDisagree").getAttribute('data-cookies_link');

        getAjax(link, function (data) {
            document.getElementById("cookiesBlock").classList.add('hidden');
            setTimeout('cookiesBlock.style.display=\'none\'', 1000);
        });
    });

    document.getElementById("cookiesAgree").addEventListener('click', function () {
        var link = document.getElementById("cookiesAgree").getAttribute('data-cookies_link');

        getAjax(link, function (data) {
            document.getElementById("cookiesBlock").classList.add('hidden');
            setTimeout('cookiesBlock.style.display=\'none\'', 1000);
        });
    });
}



// Main menu toggler;
var mainMenuHam = document.getElementById("mainMenuHam");
var mainMenu = document.getElementById("mainMenu");

mainMenuHam.addEventListener('click', function () {
    mainMenuHam.classList.toggle("open");
    mainMenu.classList.toggle("open");
    //$('.open-menu').toggleClass('open');
    //$('#header').toggleClass('active');
    //$('body').toggleClass('menu-overlay');
    //$('.main-menu-bg span').toggleClass('hidden');
});

//import Parlx from 'parlx.js';


// As a vanilla JS plugin
//const elems = document.querySelectorAll('.parallax');
//
//const parlx = new Parlx(elems, {
//    speed: 0.99
//});


//window.bgPositions = function (itemId) {
//    var element = document.getElementById(itemId);
//    var _tmp = window.getComputedStyle(element, null).backgroundPosition.trim().split(/\s+/);
//    return {
//        'left': _tmp[0],
//        'top': _tmp[1],
//        'numbers': {
//            'left': parseFloat(_tmp[0]),
//            'top': parseFloat(_tmp[1])
//        },
//        'units': {
//            'left': _tmp[0].replace(/\d+/, ''),
//            'top': _tmp[1].replace(/\d+/, '')
//        }
//    };
//}




//var direction = 1;
//var changeDirection = false;
//const maxYParallax = 100;
//const minYParallax = 0;

//window.addEventListener("scroll", function () {
//    var distance = window.scrollY;
//    //var yPosition = distance * 0.5;
//    //var currentYPosition = document.getElementById("parallax").style.backgroundPositionY;
//
//    var positions = bgPositions('parallax');
//
//    if (((positions.numbers.top > maxYParallax) && (direction === 1)) || ((positions.numbers.top < minYParallax) && (direction === -1))) {
//        changeDirection = true;
//    } else {
//        changeDirection = false;
//    }
//
//    //if ((positions.numbers.top < maxYParallax) && direction == -1) {
//    //    changeDirection = false;
//    //}
//
//    if (changeDirection == true) {
//        direction = -1 * direction;
//    }
//
//    //if ((positions.numbers.top < -minYParallax) && direction == -1) {
//    //    direction = 1;
//    //}
//
//    var newYPosition = positions.numbers.top + (direction * 0.9);
//
//    document.getElementById("parallax").style.backgroundPosition = `center ${newYPosition}px`;
//    //document.getElementById("products").style.margin  = `${newYPosition}px 0px 0px 0px`;
//    document.getElementById("products").style.marginTop = `${newYPosition}px`;
//
//    //console.log(positions.numbers.top);
//
//    //var block = document.getElementById('parallax');
//    //console.log(block);
//    //if (isInViewport(block)) {
//    //    console.log('we see this block;');
//    //}
//
//
//    //if (yPosition < maxYParallax) {
//    //document.getElementById("parallax").style.backgroundPosition = `center ${yPosition}px`;
//    //}
//
//    //document.getElementById("parallax").style.backgroundPosition = `0% 50%`;
//
//    //console.log(document.getElementById("parallax").style.backgroundPosition);
//    //document.querySelector(
//    //    ".main-banner"
//    //).style.transform = `translateY(${distance * 0.3}px)`;
//    //setTimeout(() => {
//    //    document.querySelector(".product-item").classList.add("animate-me");
//    //}, 400);
//});


//var px = Array.prototype.slice.call(document.querySelectorAll('.parallax'));
//window.addEventListener('scroll', function () {
//    parallax(px);
//})
//
//function parallax(targetElements) {
//    targetElements.forEach(el => {
//        if (inView(el)) {
//            var scroll = (window.pageYOffset - el.offsetTop) / 3;
//            var y = scroll > 0 ? -scroll : scroll;
//            el.style.backgroundPosition = "0% -" + y + "px";
//        }
//    })
//}
//
//function inView(element) {
//    var rect = element.getBoundingClientRect();
//    return (
//        rect.top >= 0 ||
//        rect.bottom <= window.innerHeight
//    );
//}






//import VueKinesis from 'vue-kinesis';
//import VueLettering from '@miii/vue-lettering'
//Vue.use(VueKinesis);

//Vue.use(VueLettering, {
//    className: (i, l, c) => `char-${i}`
//});







//var scene = document.getElementById('scene');
//var parallaxInstance = new Parallax(scene, {
//    hoverOnly: true,
//    relativeInput: true,
//    calibrateX: true,
//    calibrateY: true,
//    selector: '.layer',
//    scalarX: 1,
//    scalarY: 1,
//    frictionX: 0.075,
//    frictionY: 0.075,
//});






//$(".cookies .agree").click(function () {
//    $.get("{!! route('set.cookie', 'y') !!}", function () {});
//    $(".cookies").slideUp();
//});

//$(".cookies .disagree").click(function () {
//    $.get("{!! route('set.cookie', 'n') !!}", function () {});
//    $(".cookies").slideUp();
//});





//const app = new Vue({
//    el: '#app',
//    data: {
//        showMenu: false,
//    },
//    mounted: function () {
//        if (document.getElementById('wave')) {
//            console.log('TEST');
//            window.init();
//            window.animate();
//        }
//    },
//    methods: {
//        addClass() {
//            console.log('test');
//        },
//    },
//});


/*global jQuery */
/*!
 * Lettering.JS 0.7.0
 *
 * Copyright 2010, Dave Rupert http://daverupert.com
 * Released under the WTFPL license
 * http://sam.zoy.org/wtfpl/
 *
 * Thanks to Paul Irish - http://paulirish.com - for the feedback.
 *
 * Date: Mon Sep 20 17:14:00 2010 -0600
 */
//(function($){
//	function injector(t, splitter, klass, after) {
//		var text = t.text()
//		, a = text.split(splitter)
//		, inject = '';
//		if (a.length) {
//			$(a).each(function(i, item) {
//				inject += '<span class="letter '+klass+(i+1)+'" aria-hidden="true">'+item+'</span>'+after;
//			});
//			t.attr('aria-label',text)
//			.empty()
//			.append(inject)
//
//		}
//	}
//
//
//	var methods = {
//		init : function() {
//
//			return this.each(function() {
//				injector($(this), '', 'char', '');
//			});
//
//		},
//
//		words : function() {
//
//			return this.each(function() {
//				injector($(this), ' ', 'word', ' ');
//			});
//
//		},
//
//		lines : function() {
//
//			return this.each(function() {
//				var r = "eefec303079ad17405c889e092e105b0";
//				// Because it's hard to split a <br/> tag consistently across browsers,
//				// (*ahem* IE *ahem*), we replace all <br/> instances with an md5 hash
//				// (of the word "split").  If you're trying to use this plugin on that
//				// md5 hash string, it will fail because you're being ridiculous.
//				injector($(this).children("br").replaceWith(r).end(), r, 'line', '');
//			});
//
//		}
//	};
//
//	$.fn.lettering = function( method ) {
//		// Method calling logic
//		if ( method && methods[method] ) {
//			return methods[ method ].apply( this, [].slice.call( arguments, 1 ));
//		} else if ( method === 'letters' || ! method ) {
//			return methods.init.apply( this, [].slice.call( arguments, 0 ) ); // always pass an array
//		}
//		$.error( 'Method ' +  method + ' does not exist on jQuery.lettering' );
//		return this;
//	};
//
//})(jQuery);


//$("#circleText").lettering();
//
//
//$(".toggle-main-banner-text").on('click', function(){
//    $("#hiddenText").toggleClass("opened");
//})







//$(".cookies .agree").click(function () {
//    $.get("{!! route('set.cookie', 'y') !!}", function () {});
//    $(".cookies").slideUp();
//});
//
//$(".cookies .disagree").click(function () {
//    $.get("{!! route('set.cookie', 'n') !!}", function () {});
//    $(".cookies").slideUp();
//});







//$('.bg-holder').parallaxScroll({
//    friction: 0.3
//});
